import React from 'react'
import FormattedPrice from '@components/FormattedPrice'

interface Props {
  price: number
  priceUndiscounted: number
  currency: string
  quantity: number
}

const VariantPrice: React.FC<Props> = ({ price, priceUndiscounted, currency, quantity }) => {
  const isSale = priceUndiscounted !== price
  return (
    <div className='flex flex-col'>
      <span itemProp='price' className={`price__value text-bold ${isSale ? 'line-through' : ''}`}>
        <FormattedPrice currency={currency} amount={priceUndiscounted * (quantity || 1)} />
      </span>
      {isSale && (
        <span className='text-red'>
          <FormattedPrice currency={currency} amount={price * (quantity || 1)} />
        </span>
      )}
    </div>
  )
}

export default VariantPrice
